import { Button, ButtonProps, Typography, useTheme } from '@mui/material';
import React from 'react';

const BybPinInputButton = React.forwardRef<HTMLButtonElement, ButtonProps>((props, ref) => {
  const theme = useTheme();

  return (
    <Button
      {...props}
      ref={ref}
      disableRipple
      disableFocusRipple
      sx={{
        padding: theme.spacing(3, 6),
        borderRadius: '12px',
        textTransform: 'none',
        '&:active': {
          backgroundColor: theme.palette.dsSurface.v100,
        },
        ...props.sx,
      }}
    >
      <Typography variant="textLg500" color="dsBase.v200">
        {props.children}
      </Typography>
    </Button>
  );
});

export default BybPinInputButton;
